module.exports = __webpack_public_path__ + "static/media/ADDLABEL2.b614a3ea.svg";